<template>
  <b-modal 
    ref="modal"
    :id="id"
    title="Resultado da Pesquisa"
    header-bg-variant="warning"
    header-text-variant="dark"
    centered
    @ok="confirmar"
    @cancel="cancelar"
    @shown="onShown"
    @hidden="onHidden"
    cancel-variant="secondary"
  >
    <div class="text-center">
      <b-icon icon="exclamation-triangle" variant="warning" font-scale="3"></b-icon>
      <h5 class="mt-3">Atenção!</h5>
      <p class="mb-2">
        A pesquisa retornou <strong>{{ count }} registros</strong>.
      </p>
      <p class="mb-0">
        Isso pode deixar o sistema lento.
      </p>
      <p class="mt-3">
        <strong>Deseja continuar mesmo assim?</strong>
      </p>
    </div>
    
    <template #modal-footer="{ cancel, ok }">
      <b-button 
        ref="btnCancelar"
        variant="secondary" 
        @click="cancel()"
      >
        Não, cancelar [ESC]
      </b-button>
      <b-button 
        variant="primary" 
        @click="ok()"
      >
        Sim, carregar dados
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalAlertaResultadoGrande',
  props: {
    id: {
      type: String,
      default: 'modal-alerta-resultado-grande'
    },
    count: {
      type: Number,
      required: true
    }
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    confirmar() {
      this.$emit('confirmar')
    },
    cancelar() {
      this.$emit('cancelar')
    },
    onShown() {
      this.$nextTick(() => {
        if (this.$refs.btnCancelar) {
          this.$refs.btnCancelar.focus()
        }
      })
      this.$emit('shown')
    },
    onHidden() {
      this.$emit('hidden')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/modal/ModalAlertaResultadoGrande.vue